import { render } from "./CollaboratorsModal.vue?vue&type=template&id=491a7e84&scoped=true"
import script from "./CollaboratorsModal.vue?vue&type=script&lang=js"
export * from "./CollaboratorsModal.vue?vue&type=script&lang=js"

import "./CollaboratorsModal.vue?vue&type=style&index=0&id=491a7e84&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-491a7e84"]])

export default __exports__